<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="pointName" label="点位名称">
              <el-input clearable v-model="formData.pointName" placeholder="请输入点位名称" />

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="location" label="所在位置">
              <el-input clearable v-model="formData.location" placeholder="请输入所在位置" />

            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-form-item prop="itemLis" label="检查项">
            <el-button type="primary" style="margin-bottom: 10px;" @click="addItem">新增</el-button>

            <el-table size="mini" stripe border :data="formData.itemLis">
              <el-table-column show-overflow-tooltip min-width="100" label="检查项" prop="">
                <template v-slot="{ $index }">
                  <el-form-item :prop="'itemLis.' + $index" label="" label-width="0" :rules="[
                    {
                      required: true,
                      message: '请输入检查项',
                      trigger: ['blur', 'change']
                    }
                  ]">
                    <el-input clearable show-word-limit maxlength="200" v-model="formData.itemLis[$index]" placeholder="请输入检查项" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template v-slot="{ $index }">
                  <i class="el-icon-remove-outline del-icon" @click="deleteItem($index)"></i>

                </template>
              </el-table-column>

            </el-table>

          </el-form-item>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'inspectionPoint',

  data () {
    return {
      formData: {
        pointName: '',
        pointType: '',
        location: '',
        itemLis: []
      },
      rules: {
        pointName: [
          {
            required: true,
            message: '请输入点位名称',
            trigger: ['blur', 'change']
          }
        ],
        location: [
          {
            required: true,
            message: '请输入所在位置',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false

    }
  },
  created () {
    if (this.pointId) {
      this.loadData()
    }
  },
  computed: {
    pointId () {
      return this.$route.query.pointId
    },
    pointType () {
      return this.$route.query.pointType
    }
  },
  methods: {
    addItem () {
      this.formData.itemLis.push('')
    },
    deleteItem (index) {
      this.formData.itemLis.splice(index, 1)
    },

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.inspectionPoint.selectPaInspectPointByPointId, {
          params: { pointId: this.pointId }
        })
        .then(res => {
          res.itemLis = res.itemLis ? res.itemLis : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.inspectionPoint.insertPaInspectPoint
          if (this.pointId) {
            url = this.$apis.inspectionPoint.updatePaInspectPoint
          }

          this.$axios.post(url, { ...this.formData, pointType: this.pointType }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

</style>
